import React from "react";
import { Card, CardMedia, IconButton } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const ImageCard = ({ imageUrl, onDelete }) => {
  return (
    <div style={{ position: "relative", margin: "0 8px" }}>
      <Card sx={{ maxWidth: 345, boxShadow: "none" }}>
        <CardMedia component="img" height="140" image={imageUrl} alt="Uploaded Image" />
      </Card>
      <IconButton
        onClick={onDelete}
        color="error"
        style={{
          position: "absolute",
          top: 8,
          right: 8,
        }}>
        <CloseOutlinedIcon />
      </IconButton>
    </div>
  );
};

export default ImageCard;
